import { useContext } from 'react'
import { ThemeModeContext } from '../providers/ThemeModeProvider'

export const useThemeMode = () => {
  const { isDarkMode, toggleThemeMode } = useContext(ThemeModeContext)

  return {
    isDarkMode,
    toggleThemeMode,
  }
}
